<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <router-link class="btn btn-primary mb-4" to="/dashboard/shopnew">افزودن مورد جدید</router-link>
            <div class="row">
              <p>فیلتر</p>
              <div class="btn-group p-3 d-flex flex-row align-content-center align-items-center">
                <div v-for="(item, index) in shopItems" :key="index">
                  <div :id="`Menu${index}`" class="accordion-icon ml-2">
                    <button v-if="selected.itemType == item.itemType" class="btn btn-success">
                      {{ item.itemName }}
                    </button>
                    <button v-else class="btn btn-outline-secondary" @click="changeFilter(index)">
                      {{ item.itemName }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <p>{{ selected.itemName }}</p>
              <div
                v-if="selected.itemType == 'Skin'"
                class="btn-group p-3 d-flex flex-row align-content-center align-items-center"
              >
                <div v-for="(item, index) in skinFilters" :key="index">
                  <div :id="`Menu${index}`" class="accordion-icon ml-2">
                    <button v-if="selectedSkinFilter.itemType == item.itemType" class="btn btn-success">
                      {{ item.itemName }}
                    </button>
                    <button v-else class="btn btn-outline-secondary" @click="changeSkinFilter(index)">
                      {{ item.itemName }}
                    </button>
                  </div>
                </div>
              </div>
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>عنوان در فروشگاه</th>
                    <th v-if="selected.itemType != 'coin' && selected.itemType != 'ticket'">نام آیتم</th>
                    <th v-if="selected.itemType != 'coin' && selected.itemType != 'ticket'">ایندکس آیتم</th>
                    <th v-if="selected.itemType != 'coin' && selected.itemType != 'ticket'">سکه</th>
                    <th v-if="selected.itemType == 'coin' || selected.itemType == 'ticket'">هزینه تومان</th>
                    <th v-if="selected.itemType == 'coin' || selected.itemType == 'ticket'">هزینه دلاری</th>
                    <th>وضعیت</th>
                    <th>جزییات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="detail in selected.items" :key="detail._id">
                    <td>{{ detail.title }}</td>
                    <td v-if="selected.itemType == 'Skin'">{{ detail.skin.skinName }}</td>
                    <td v-if="selected.itemType == 'Skin'">{{ detail.skin.skinIndex }}</td>
                    <td v-if="selected.itemType == 'Formation'">{{ detail.formation.formationName }}</td>
                    <td v-if="selected.itemType == 'Formation'">{{ detail.formation.formationIndex }}</td>
                    <td v-if="selected.itemType == 'Chat'">{{ detail.chat.packageTitle }}</td>
                    <td v-if="selected.itemType == 'Chat'">{{ detail.chat.chatIndex }}</td>
                    <td v-if="selected.itemType == 'Avatar'">{{ detail.avatar.avatarName }}</td>
                    <td v-if="selected.itemType == 'Avatar'">{{ detail.avatar.avatarIndex }}</td>
                    <td>{{ price(detail).price }}</td>
                    <td v-if="selected.itemType == 'coin' || selected.itemType == 'ticket'">
                      {{ detail.dollarPrice }}
                    </td>
                    <td>{{ detail.isAvailable ? 'فعال' : 'غیر فعال' }}</td>
                    <td>
                      <router-link :to="{ path: '/dashboard/shopdetail', query: { id: detail._id } }"
                        >مشاهده</router-link
                      >
                      <button @click="deleteItem(detail)" class="btn btn-gradient-01 ml-4">حذف</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
    </div>
    <!-- End Row -->
  </div>
</template>

<script>
import shopService from '../../../../services/shop';
import _ from 'lodash';
export default {
  name: 'shop',
  data() {
    return {
      shopItems: [],
      selectedSkinFilter: {},
      skinFilters: [
        {
          itemName: 'مهره باشگاهی',
          itemType: 'ClubTeam',
        },
        {
          itemName: 'ملی',
          itemType: 'NationalTeam',
        },
        {
          itemName: 'خاص',
          itemType: 'Other',
        },
      ],
      selected: { itemName: '', items: [] },
    };
  },
  created() {
    this.getItems();
  },
  methods: {
    async getItems() {
      try {
        const shopItems = await shopService.getItems();
        // console.log(shopItems);
        this.shopItems = shopItems;
        if (shopItems.length > 0) {
          this.selected = _.clone(shopItems[0]);
          this.selected.items = this.selected.items.filter(a => a.skin.skinCat == 'ClubTeam');
          this.selectedSkinFilter = this.skinFilters[0];
        }
      } catch (err) {
        console.log(err);
      }
    },
    changeSkinFilter(index) {
      const skins = _.clone(this.shopItems[0]);
      this.selected.items = skins.items.filter(a => a.skin.skinCat == this.skinFilters[index].itemType);
      this.selectedSkinFilter = this.skinFilters[index];
    },
    changeFilter(index) {
      this.selected = _.clone(this.shopItems[index]);
      if (index == 0) {
        this.selected.items = this.selected.items.filter(a => a.skin.skinCat == this.selectedSkinFilter.itemType);
      }
    },

    async deleteItem(item) {
      try {
        await shopService.deleteItem({ _id: item._id });
        window.notif({ isError: false, mssg: 'ایتم حذف شد' });
        this.getItems();
      } catch (err) {
        window.notif({ isError: true, mssg: 'مشکلی پیش آمده' });
      }
    },

    price(item) {
      if (item.cashAvailable) return { type: 'نقدی', price: item.cashPrice };

      if (item.coinAvailable) return { type: 'سکه', price: item.coinPrice };

      return { type: 'نامشخص', price: 'نامشخص' };
    },
  },
};
</script>
